import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { usePaymentTabData } from '@/features/settings/hooks';
import { Button } from '@/shared/components/ui/Button';
import { Separator } from '@/shared/components/ui/Separator';

import { tabContainer, tabLabelColumn, tabLabelText, tabRow, tabSectionCopy } from './settingsTab.styles';

export const PaymentTab: FC = () => {
  const { t, i18n } = useTranslation();
  const { showCancelButton, cancelAt, handlePaymentMethodAndInvoices, handleSubscriptionCancel } = usePaymentTabData();

  const subscriptionCopy = showCancelButton
    ? t('settings.payment.activeUntilPeriodEnd')
    : cancelAt
      ? t(cancelAt.getTime() > Date.now() ? 'settings.payment.endsOn' : 'settings.payment.cancelledOn', {
          date: cancelAt.toLocaleDateString(i18n.language),
        })
      : null;

  return (
    <div className={tabContainer}>
      <div className={tabRow}>
        <div className={tabLabelColumn}>
          <span className={tabLabelText}>{t('settings.payment.methodAndInvoices')}</span>
          <span className={tabSectionCopy}>{t('settings.payment.methodAndInvoicesHint')}</span>
        </div>
        <Button variant="primary" showLoader onClick={handlePaymentMethodAndInvoices}>
          {t('settings.payment.manage')}
        </Button>
      </div>

      {subscriptionCopy && (
        <>
          <Separator />
          <div className={tabRow}>
            <div className={tabLabelColumn}>
              <span className={tabLabelText}>{t('settings.payment.subscription')}</span>
              <span className={tabSectionCopy}>{subscriptionCopy}</span>
            </div>
            {showCancelButton && (
              <Button variant="danger" showLoader onClick={handleSubscriptionCancel}>
                {t('settings.payment.cancel')}
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};
